import { render, staticRenderFns } from "./PremiumLicenseProjectForm.vue?vue&type=template&id=4f18b31c"
import script from "./PremiumLicenseProjectForm.vue?vue&type=script&lang=js"
export * from "./PremiumLicenseProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports